import React from 'react';

function ModalLoader() {
  return (
    <div className="animate-pulse relative px-6 py-2">
      <div className="my-4 text-slate-500 text-lg flex flex-col md:flex-row gap-x-10 w-full leading-relaxed">
        <div className={'bg-slate-200 w-full mb-10 md:w-1/2 aspect-video'}></div>
        <h5 className="flex-1 mb-10 text-2xl font-bold tracking-tight  text-gray-50 dark:text-white">
          <div className="grid grid-cols-3 gap-4 mt-1">
            <div className="h-4 bg-slate-200 rounded col-span-2"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">
            <div className="h-4 bg-slate-200 rounded col-span-1"></div>
          </div>
          <div className="grid grid-cols-3 gap-4 mt-1">
            <div className="h-4 bg-slate-200 rounded col-span-2"></div>
          </div>
          <div className="grid grid-cols-3 gap-4 mt-2">
            <div className="h-4 bg-slate-200 rounded col-span-1"></div>
          </div>
          <div className="mt-10">
            <div className="grid grid-cols-3 gap-4 mt-1">
              <div className="h-4 bg-slate-200 rounded col-span-2"></div>
            </div>
            <div className="grid grid-cols-3 gap-4 mt-2">
              <div className="h-4 bg-slate-200 rounded col-span-1"></div>
            </div>
          </div>
          <div className="mt-20">
            <div className="grid grid-cols-3 gap-4 mt-1">
              <div className="h-4 bg-slate-200 rounded col-span-2"></div>
            </div>
            <div className="grid grid-cols-3 gap-4 mt-2">
              <div className="h-4 bg-slate-200 rounded col-span-1"></div>
            </div>
          </div>
        </h5>
      </div>
    </div>
  );
}

export default ModalLoader;
